import styled from "styled-components";

const TextArea = styled.textarea`
  width: 85%;
  height: ${({ theme }) => theme.CONSTANTS.XH * 42}px;
  padding: 16px;
  background: rgba(0, 6, 22, 0.6);
  border: 1px solid ${({ theme }) => theme.THEME.grayText};
  border-radius: 12px;
  color: ${({ theme }) => theme.THEME.white};
  font-family: "Inter", sans-serif;
  resize: none;
  font-size: 16px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.THEME.neonBlue};
  }
`;

export default TextArea;
